module.exports = __webpack_public_path__ + "static/shareWater2BG-c5f0496a27d5141fe9d0e46660b7e71d.png";